import { ProjectRepository } from 'core/repositories/ProjectRepository';
import { createDependency } from 'services/createDependency';

export const [useProjectRepository, withProjectRepository] = createDependency<ProjectRepository>();
